import AppHeader from "@saleor/components/AppHeader";
// import CardSpacer from "@saleor/components/CardSpacer";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";
import Grid from "@saleor/components/Grid";
import PageHeader from "@saleor/components/PageHeader";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
// import { DiscountErrorFragment } from "@saleor/fragments/types/DiscountErrorFragment";
import { sectionNames } from "@saleor/intl";
import { CreateProducttags_producttagsCreate_errors } from "@saleor/producttags/types/CreateProducttags";
import React from "react";
import { useIntl } from "react-intl";

import {
  ProductTagsTagType,
  SaleType as SaleTypeEnum
} from "../../../types/globalTypes";
// import DiscountDates from "../DiscountDates";
import ProductTagInfo from "../ProductTagInfo";
// import SaleType from "../SaleType";

export interface FormData {
  endDate: string;
  endTime: string;
  hasEndDate: boolean;
  title: string;
  name: string;
  stickersImage: string;
  stickersImageLocationX: number;
  stickersImageLocationY: number;
  showTag: boolean;
  startDate: string;
  startTime: string;
  tagType: ProductTagsTagType;
  type: SaleTypeEnum;
  value: string;
  cornerMark: string;
  componentFontColor?: string;
  productFontColor?: string;
  productBackgroundColor?: string;
}

export interface SaleCreatePageProps {
  defaultCurrency: string;
  disabled: boolean;
  errors: CreateProducttags_producttagsCreate_errors[];
  saveButtonBarState: ConfirmButtonTransitionState;
  onBack: () => void;
  onSubmit: (data: FormData) => void;
}

const SaleCreatePage: React.FC<SaleCreatePageProps> = ({
  // defaultCurrency,
  disabled,
  errors,
  onSubmit,
  saveButtonBarState,
  onBack
}) => {
  const intl = useIntl();

  const initialForm: FormData = {
    endDate: "",
    endTime: "",
    hasEndDate: false,
    title: "",
    name: "",
    startDate: "",
    startTime: "",
    tagType: ProductTagsTagType.TEXT,
    type: SaleTypeEnum.FIXED,
    value: "",
    cornerMark: "",
    stickersImage: "",
    stickersImageLocationX: 0,
    stickersImageLocationY: 0,
    showTag: true,
    componentFontColor: "",
    productFontColor: "",
    productBackgroundColor: ""
  };
  return (
    <Form initial={initialForm} onSubmit={onSubmit}>
      {({ change, data, hasChanged, setNameValue, submit }) => (
        <Container>
          <AppHeader onBack={onBack}>
            {intl.formatMessage(sectionNames.producttags)}
          </AppHeader>
          <PageHeader
            title={intl.formatMessage({
              defaultMessage: "Create ProductTag",
              description: "page header"
            })}
          />
          <Grid>
            <div>
              <ProductTagInfo
                data={data}
                disabled={disabled}
                errors={errors}
                onChange={change}
                setNameValue={setNameValue}
              />
              {/* <SaleInfo
                data={data}
                disabled={disabled}
                errors={errors}
                onChange={change}
              />
              <CardSpacer />
              <SaleType data={data} disabled={disabled} onChange={change} />
              <CardSpacer />
              <DiscountDates
                data={data}
                disabled={disabled}
                defaultCurrency={defaultCurrency}
                errors={errors}
                onChange={change}
              /> */}
            </div>
          </Grid>
          <SaveButtonBar
            disabled={disabled || !hasChanged}
            onCancel={onBack}
            onSave={submit}
            state={saveButtonBarState}
          />
        </Container>
      )}
    </Form>
  );
};
SaleCreatePage.displayName = "SaleCreatePage";
export default SaleCreatePage;
